import { UserOffice } from "@type/core/auth/auth.types";
import { TransactionForm } from "@type/core/transaction/transaction.types";

const computeConfidentiality = (
  transactionOffice?: UserOffice /*, previousId?: string*/,
  transactionForm?: TransactionForm,
): boolean | undefined => {
  // TODO A valider mais les tests unitaires indiquent les mêmes résultats entre ces deux versions
  // if (
  //     transactionOffice?.isConfidential ||
  //     transactionOffice?.isConfidentialByDefault
  // ) {
  //     return true;
  // }
  // //On reset la confidentialité seulement si l'office selectionné a changé
  // if (
  //     (previousId !== transactionOffice?.id) &&
  //     !transactionOffice?.isConfidential &&
  //     !transactionOffice?.isConfidentialByDefault
  // ) {
  //     return false;
  // }
  //
  // return false;

  return (
    transactionForm?.confidential ||
    transactionOffice?.isConfidential ||
    transactionOffice?.isConfidentialByDefault
  );
};

export const signatureService = {
  computeConfidentiality,
};
